import { render } from "./PageAduan.vue?vue&type=template&id=3e57c054"
import script from "./PageAduan.vue?vue&type=script&lang=js"
export * from "./PageAduan.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__